import moment from 'moment';
import React, { useEffect } from 'react';

import ExportModalWithStoresAndPeriod from '@commons/ExportModalWithStoresAndPeriod';

import { usePeriodDatePickerState } from '@hooks/usePeriodDatePickerState';

import { ExportModalContainer } from './styledComponents';

export const ProductMixExportModal = (props) => {
  const {
    maxDaysInFuture,
    allowPastDates,
    currentDate,
    exportModalStores,
    groups,
    selectedGroups,
    setSelectedGroups,
    exportSelectedStore,
    setExportSelectedStore,
    setExportPeriod,
    clientStoreName,
    defaultTimezone,
  } = props;

  const periodPickerState = usePeriodDatePickerState(currentDate, currentDate, defaultTimezone);

  useEffect(() => {
    if (!periodPickerState.startDate || !periodPickerState.endDate) {
      return;
    }

    setExportPeriod({ startDate: periodPickerState.startDate, endDate: periodPickerState.endDate });
  }, [periodPickerState.startDate, periodPickerState.endDate]);

  return (
    <ExportModalContainer>
      <ExportModalWithStoresAndPeriod
        clientStoreName={clientStoreName}
        defaultTimezone={defaultTimezone}
        filteredStores={exportModalStores}
        groups={groups}
        maxFutureDate={moment().add(maxDaysInFuture, 'days').endOf('day')}
        maxPastDate={
          allowPastDates ? moment().subtract(12, 'months').startOf('day') : moment().startOf('day')
        }
        periodPickerState={periodPickerState}
        selectedGroups={selectedGroups}
        selectedStores={[exportSelectedStore]}
        setSelectedGroups={setSelectedGroups}
        setSelectedStores={setExportSelectedStore}
        isUniqueStoreSelection
      />
    </ExportModalContainer>
  );
};

export default ProductMixExportModal;
